import { z } from 'zod';

/**
 * Paramètres d'URL de l'écran Transporteurs (`02` §9).
 *
 * Deux onglets seulement : la liste ordonnée des règles et le simulateur (qui
 * porte aussi la matrice de couverture). L'onglet actif vit dans l'URL pour
 * rester « bookmarkable », comme Paramètres et Journal.
 */
export const TRANSPORTEURS_TABS = ['regles', 'simulateur'] as const;

export type TransporteursTab = (typeof TRANSPORTEURS_TABS)[number];

const transporteursSearchSchema = z.object({
  tab: z.enum(TRANSPORTEURS_TABS).optional(),
  /** Boutique de la matrice de couverture, dans l'onglet Simulateur. */
  store: z.string().optional(),
});

export interface TransporteursSearch {
  tab: TransporteursTab;
  store: string | undefined;
}

function readRecord(value: unknown): Record<string, unknown> {
  return typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : {};
}

/** Lecture générique depuis `useSearch({strict:false})`, testable hors routeur. */
export function readTransporteursSearch(rawSearch: unknown): TransporteursSearch {
  const parsed = transporteursSearchSchema.safeParse(readRecord(rawSearch));
  return {
    tab: (parsed.success ? parsed.data.tab : undefined) ?? 'regles',
    store: parsed.success ? parsed.data.store : undefined,
  };
}

/** `validateSearch` de `routes/transporteurs.tsx`. */
export function parseTransporteursSearch(
  search: Record<string, unknown>,
): { tab?: TransporteursTab | undefined; store?: string | undefined } {
  return transporteursSearchSchema.parse(search);
}
